.root {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--st-in);
  /* ОСОЗНАННОЕ ОТСТУПЛЕНИЕ ОТ МАКЕТА — не «чинить» обратно на #fff.
     Макет красит инициалы литеральным #fff в обеих темах. Но в тёмной теме плитки
     становятся СВЕТЛЕЕ (--st-in там oklch(72%) против oklch(56%) в светлой), и белым по
     светлому получается 2.35:1 при норме AA 4.5:1 — измерено lighthouse на живой сборке.
     --on-accent — токен ровно для этого случая, «текст НА цветной поверхности»: в светлой
     теме он ≈ белый (макет не меняется), в тёмной — тёмный (2.35 → ~8.5:1). Так уже
     работают акцентная кнопка и плитка «P» на странице входа. Решение заказчика. */
  color: var(--on-accent);
  font-weight: 600;
}

.sm {
  width: 28px;
  height: 28px;
  font-size: 11px;
}

.lg {
  width: 42px;
  height: 42px;
  font-size: 15px;
}
